import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsDeleteRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-delete',
	path: '(/secure/|/)DeletePortalPage([!%]?[\\w]*).jspa',
};
